import React from 'react';
import { Button } from 'react-bootstrap';
import { StateCombobox } from '../components/StateCombobox';
import logService from '../services/LogService';
import { InstanceCombobox } from '../components/InstanceCombobox';
import { useSelector, useDispatch } from "react-redux";
import { setRequestMessage, setProcessingState } from "../actions/searchAction";
import { DetailHistoryCombobox } from '../components/DetailHistoryCombobox';


export const Sender = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const handleSendRequest = async () => {
    dispatch(setProcessingState(true));
    await logService.postRequest(state.serverInstance, state.searchModel.authorityName, state.requestMessage);
    dispatch(setProcessingState(false));
  }

  const validateMessage = () => {
    if (state.requestMessage === undefined ||
      state.requestMessage === null ||
      state.requestMessage === "") {
      return false;
    }

    try {
      JSON.parse(state.requestMessage);
    } catch (e) {
      return false;
    }

    if (state.searchModel.authorityName === undefined ||
      state.searchModel.authorityName === null ||
      state.searchModel.authorityName === "") {
      return false;
    }

    return true;
  }

  const handleRequestMessageChange = (requestMessage) => {
    dispatch(setRequestMessage(requestMessage));
  }

  return (
    <>
      <h1>Message Tester</h1>
      <div className='row justify-content-start'>
        <div className='col-md-2 px-md-1'>
          <StateCombobox />
        </div>
        <div className="col-md-2 align-self-end">
          <InstanceCombobox />
        </div>
        <div className="col-md-4 align-self-end">
          <DetailHistoryCombobox
            className='btn btn-primary'
          />
        </div>
      </div>
      <br />
      <h5>Enter a request json string</h5>
      <div>
        <textarea className="form-control" rows="10" value={state.requestMessage} onChange={(e) => handleRequestMessageChange(e.target.value)} />
      </div>
      <br />
      <div className="clearfix">
        <Button onClick={handleSendRequest} disabled={!validateMessage()} >Send Request</Button>
      </div>
      {state.processingState && <div className="info"><span>Processing Request...</span></div>}
    </>
  );
}

